<script>
import Spacer from 'linna/components/Spacer'

import StyledLinkButton from '@/components/snippets/StyledLinkButton'
import Clock from '@/components/widgets/Clock'

import shortcuts from '@/config/shortcuts'

export default {
  name: 'GameNavigationBottom',

  components: {
    Clock,
    Spacer,
    StyledLinkButton
  },

  data () {
    return {
      shortcuts: {
        config: shortcuts.config
      }
    }
  }
}
</script>

<template>
  <div class="c-game-navigation-bottom">
    <div class="c-game-navigation-bottom-content">

      <styled-link-button
        :to="{ name: 'debug' }"
        class="c-game-navigation-bottom-item"
      >
        DBUG
      </styled-link-button>

      <spacer />

      <clock class="c-game-navigation-top-item" />

      <spacer />

      <styled-link-button
        :shortcut="shortcuts.config"
        :to="{ name: 'settings' }"
        class="c-game-navigation-bottom-item"
      >
        CNF[G]
      </styled-link-button>

    </div>
  </div>
</template>

<style lang="scss">

.c-game-navigation-bottom-content {
  @include flex;
}

.c-game-navigation-bottom-item {
  @include pad;

  &.router-link-exact-active {
    @include underline;
  }

}

</style>
